



































































import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import CalculationInput from '@/tasks/components/inputs/CalculationInput.vue';

export default {
  name: 'UOttawaLabExamPt22025',
  components: {CalculationInput},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        equipment: [],
        unknownNumber: null,
        g: null,
        ml: null,
        gPerCm3: null,
      },
      items: [
        {label: '50 mL beaker', value: 'beaker_50ml'},
        {label: '150 mL beaker', value: 'beaker_150ml'},
        {label: '250 mL beaker', value: 'beaker_250ml'},
        {label: '400 mL beaker', value: 'beaker_400ml'},
        {label: '600 mL beaker', value: 'beaker_600ml'},
        {label: '125 mL Erlenmeyer flask', value: 'erlenmeyer_flask'},
        {label: '10 mL graduated cylinder', value: 'graduated_cylinder_10ml'},
        {label: '50 mL graduated cylinder', value: 'graduated_cylinder_50ml'},
        {label: '60 mL funnel', value: 'funnel_60ml'},
        {label: '250 mL wash bottle', value: 'wash_bottle'},
        {label: '75 mL watch glass', value: 'watch_glass'},
        {label: 'Balance', value: 'balance'},
        {label: 'Clamp holder', value: 'clamp_holder'},
        {label: 'Crucible tongs', value: 'crucible_tongs'},
        {label: 'Extension clamp', value: 'clamp_extension'},
        {label: 'Scoopula', value: 'scoopula'},
        {label: 'Spatula', value: 'spatula'},
        {label: 'Teflon rod', value: 'teflon_rod'},
        {label: 'Test tube holder', value: 'test_tube_holder'},
        {label: 'Test tube rack', value: 'test_tube_rack'},
        {label: 'Universal clamp (3 finger)', value: 'clamp_universal'},
        {label: 'Weighing paper', value: 'weighing_paper'},
      ],
    };
  },
};
